import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';

import { SliceAccordionSettings } from './settings/slice-accordion-settings.model';


export const SliceAccordionDefinition: IdtComponentDefinition = {
  id: 'slice-accordion',
  role: IdtComponentRole.Slice,
  numSlots: 1,
  defaultSlot: 1
};

export const SliceAccordionCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Acordeón',
  group: CmsComponentGroups.Components,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): SliceAccordionSettings => ({
    general: {
      numSlots: 1,
      headers: [{
        alt: 'Elemento 1',
        text: ''
      }],
      headerType: 'text',
      headerIcon: {
        position: 'right',
        width: '20px',
        height: '20px'
      },
      openMode: 'click',
      allowExpandMultipleHeader: false,
      transitionType: 'none'
    },
    slots: [
      { ...initialSliceSlotState }
    ],
    styles: {
      ...SliceStylesDefaultValues,
      accordionAppearance: {
        theme: 'default'
      }
    }
  })
};
